import { render, staticRenderFns } from "./VOption.vue?vue&type=template&id=1e785f60&"
import script from "./VOption.vue?vue&type=script&lang=js&"
export * from "./VOption.vue?vue&type=script&lang=js&"
import style0 from "./VOption.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports